import { useState, useEffect } from 'react'
import { Menu, X, Flame } from 'lucide-react'

const navItems = [
  { name: '首页', href: '/', type: 'navigate' },
  { name: '产品中心', href: '/products', type: 'navigate' },
  { name: '新闻资讯', href: '/news', type: 'navigate' },
  { name: '资料中心', href: '/resources', type: 'navigate' },
  { name: '关于我们', href: '/about', type: 'navigate' },
  { name: '联系我们', href: '/contact', type: 'navigate' },
]

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleNavClick = (href: string, type: string) => {
    if (type === 'scroll') {
      const element = document.querySelector(href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    } else if (type === 'navigate') {
      window.location.href = href
    }
    setIsMobileMenuOpen(false)
  }

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className={`p-2 rounded-lg ${isScrolled ? 'bg-primary-600' : 'bg-white/20'}`}>
              <Flame className={`w-6 h-6 ${isScrolled ? 'text-white' : 'text-white'}`} />
            </div>
            <div className="flex flex-col">
              <span
                className={`text-xl font-bold tracking-tight ${
                  isScrolled ? 'text-secondary-900' : 'text-white'
                }`}
              >
                云净炉业
              </span>
              <span
                className={`text-xs ${
                  isScrolled ? 'text-secondary-500' : 'text-white/70'
                }`}
              >
                YUNJING FURNACE
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavClick(item.href, item.type)}
                className={`text-sm font-medium transition-colors duration-200 hover:text-primary-500 ${
                  isScrolled ? 'text-secondary-700' : 'text-white/90'
                }`}
              >
                {item.name}
              </button>
            ))}
            <button
              onClick={() => handleNavClick('#contact', 'scroll')}
              className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 ${
                isScrolled
                  ? 'bg-primary-600 text-white hover:bg-primary-700'
                  : 'bg-white text-primary-700 hover:bg-white/90'
              }`}
            >
              在线咨询
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isScrolled ? 'text-secondary-700 hover:bg-secondary-100' : 'text-white hover:bg-white/10'
            }`}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-white/10">
            <div className="flex flex-col gap-2 pt-4">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavClick(item.href, item.type)}
                  className={`text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    isScrolled
                      ? 'text-secondary-700 hover:bg-secondary-50'
                      : 'text-white hover:bg-white/10'
                  }`}
                >
                  {item.name}
                </button>
              ))}
              <button
                onClick={() => handleNavClick('#contact', 'scroll')}
                className={`mt-2 px-4 py-3 rounded-lg text-sm font-semibold text-center transition-colors ${
                  isScrolled
                    ? 'bg-primary-600 text-white hover:bg-primary-700'
                    : 'bg-white text-primary-700 hover:bg-white/90'
                }`}
              >
                在线咨询
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  )
}
